function Discount(){
  this.pound_products = {}; 
  this.csv_discount = {};
  this.csv_url = "";
}
Discount.prototype.quantity=function(product_handle,qty){
    let unit_quantity = 1;
    if( typeof this.pound_products[product_handle] !== "undefined" ){
        unit_quantity = this.pound_products[product_handle].step;
    }
    return qty*unit_quantity;
};
Discount.prototype.discount=function(product_id,variant_id,qty){
    //if( typeof this.csv_discount[product_id] === "undefined" || typeof this.csv_discount[product_id][variant_id] === "undefined" ) return 0;
    if( typeof this.csv_discount[product_id] === "undefined" ) return 0;
    let discount = 0;
    let data_array = this.csv_discount[product_id];

    if( typeof this.csv_discount[product_id][variant_id] !== "undefined" ) data_array = this.csv_discount[product_id][variant_id];
    //console.log(data_array);
    for( let key_qty in data_array ){
        let data = data_array[key_qty];
        if( qty>=key_qty ){
            discount = data["discount"];
        }
    }
    /*
    for( let key_qty in this.csv_discount[product_id][variant_id] ){
        let data = this.csv_discount[product_id][variant_id][key_qty];
        if( qty>=key_qty ){
            discount = data["discount"];
        }
    }
    */
    return discount;
};
Discount.prototype.discountData=function(product_id,variant_id,qty){
    //if( typeof this.csv_discount === "undefined" || typeof this.csv_discount[product_id] === "undefined" || typeof this.csv_discount[product_id][variant_id] === "undefined" ) return null;
    if( typeof this.csv_discount === "undefined" || typeof this.csv_discount[product_id] === "undefined" ) return null;
    let return_data = null;

    let data_array = this.csv_discount[product_id];
    if( typeof this.csv_discount[product_id][variant_id] !== "undefined" ) data_array = this.csv_discount[product_id][variant_id];

    for( let key_qty in data_array ){
        let data = data_array[key_qty];
        if( qty>=parseInt(key_qty) ){
            return_data = data;
            return_data["quantity"] = key_qty;
        }
    }
    /*
    for( let key_qty in this.csv_discount[product_id][variant_id] ){
        let data = this.csv_discount[product_id][variant_id][key_qty];
        if( qty>=parseInt(key_qty) ){
            return_data = data;
            return_data["quantity"] = key_qty;
        }
    }
    */
    return return_data;
};
Discount.prototype.isPound=function(product_handle){
    if( typeof this.pound_products[product_handle] !== "undefined" ) return true;
    else return false;
};
Discount.prototype.poundStep=function(product_handle){
    if( typeof this.pound_products[product_handle] === "undefined" ) return null;
    return this.pound_products[product_handle].step;
};
Discount.prototype.initialCSVDiscounts=function(callback){
    this.csv_discount = {};
    //console.log( this.csv_url );
    fetch(this.csv_url, {
        method: 'GET'
    }).then(function (response) {
        return response.text();
    }).then((result) => {
        let rows = result.split("\r\n");
        //let rows = result.split("\n");
        //console.log(rows);
        let count = 0;
        //let variant_id = "";
        for(let key in rows){
            count++;
            if( count===1 ) continue;
            let row = rows[key];
            let data = row.split(",");
            
            /*
            if( data.length!=4 ) continue;
            let product_id = data[3];
            let price_per_pound = data[2];
            let discount = parseFloat(data[1].replace("%",""));
            let quantity = data[0];
            */

            /*
            if( data.length!=5 ) continue;
            let product_id = data[0];
            let variant_id = data[1];
            let discount = parseFloat(data[2].replace("%",""));
            let quantity = data[3];
            let price_per_pound = data[4];
            */

            if( data.length!=5 ) continue;
            let product_id = data[3];
            //if( data[4]!=="" ) variant_id = data[4];
            let variant_id = data[4];
            let discount = parseFloat(data[1].replace("%",""))*100;
            let quantity = data[0];
            let price_per_pound = data[2];
            

            if( typeof this.csv_discount[product_id] === "undefined" ) this.csv_discount[product_id] = {};
            
            
            if( variant_id!=="" ){
                if( typeof this.csv_discount[product_id][variant_id] === "undefined" ) this.csv_discount[product_id][variant_id] = {};

                this.csv_discount[product_id][variant_id][quantity] = {
                    "price":    price_per_pound,
                    "discount": discount
                };
            }
            else{
                this.csv_discount[product_id][quantity] = {
                    "price":    price_per_pound,
                    "discount": discount
                };
            }
            
        }
        //console.log(this.csv_discount);
        callback();
    },
    (error) => {});
};
Discount.prototype.getCountry=function(callback){
  return callback("US");
    $.get("https://ipinfo.io", function(response) {
        console.log(response.city, response.country);
        callback(response.country);
    }, "jsonp");
};
var __discount_object = new Discount();

__discount_object.pound_products["smooth-nectar-5lb-hard-wax"] = {step: 5};
__discount_object.pound_products["wild-honey-hard-polymer-film-wax"] = {step: 5};
//__discount_object.csv_url = "https://cdn.shopify.com/s/files/1/0458/1556/2391/files/discounts4.csv?v=1660935188";